/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import React, { useState, useRef } from "react";
import {
  Col,
  Row,
  Form,
  Button,
  ButtonGroup,
  InputGroup,
  Dropdown,
} from "react-bootstrap";
import { CheckIcon, CogIcon, SearchIcon } from "@heroicons/react/solid";

export interface ISettingsCompProps {
  searchPlaceholderText?: string;
  searchStatusFilter?: {
    value: string;
    label: string;
  }[];
  typeOfSearch?: {
    value: string;
    label: string;
  }[];
  onSearchValue?(name: string): void;
  onStatusFilter?(value: string): void;
  settingsEntriesLabel?: string;
  onApplyFilter?(filterData: any);
  applyLabel?: string;
  clearLabel?: string;
  typeStyle?: any;
  settingsEntries?: {
    value: string;
    label: string;
  }[];
  onSettingEntryChange(value: string): void;
}

export const SettingsComp = ({
  searchPlaceholderText,
  searchStatusFilter,
  typeOfSearch,
  onSearchValue,
  onStatusFilter,
  settingsEntriesLabel,
  settingsEntries,
  applyLabel,
  clearLabel,
  typeStyle,
  onSettingEntryChange,
  onApplyFilter,
}: ISettingsCompProps) => {
  const [searchValue, setSearchValue] = useState("");
  const [statusFilter, setStatusFilter] = useState(null);
  const [settingEntry, setSettingEntry] = useState("10");
  const [typeFilter, setTypeFilter] = useState();
  const [disableApply, setDisableApply] = useState(true);
  const changeSearchValue = (e) => {
    const newSearchValue = e.target.value;
    setSearchValue(newSearchValue);
    setDisableApply(false);
    // if (onSearchValue) {
    //   onSearchValue(newSearchValue?.toLowerCase());
    // }
  };

  const changeTypeFilter = (e) => {
    console.log(`on change type`, e);
    const newTypeFilter = e.target.value;
    setTypeFilter(newTypeFilter);
  };

  const _getStatus = (status: string) => {
    switch (status) {
      case "active":
        return "ACC_CREATED";
      case "invited":
        return "INVITED";
      case "suspended":
        return "SUSPENDED";
      default:
        return null;
    }
  };

  const applyFilterAction = () => {
    let _data = {};
    _data[typeFilter] = searchValue;
    _data.accountStatus__in = _getStatus(statusFilter);

    onApplyFilter && onApplyFilter(_data);
  };

  const changeStatusFilter = (e) => {
    const newStatusFilter = e.target.value;
    setStatusFilter(newStatusFilter);
    setDisableApply(false);
    // if (onStatusFilter) {
    //   onStatusFilter(newStatusFilter);
    // }
  };

  const changeSettingEntry = (e) => {
    setSettingEntry(e);
    if (onSettingEntryChange) {
      onSettingEntryChange(e);
    }
  };

  const clearFilter = () => {
    setSearchValue("");
    setStatusFilter(0);
    setDisableApply(true);
  };

  const _getCheckIcon = (value) => {
    if (value && value === settingEntry) {
      return <CheckIcon className="icon icon-xxs ms-auto" />;
    }
    return <></>;
  };

  return (
    <div className="table-settings mb-4">
      <Row className="justify-content-between align-items-center">
        <Col xs={9} lg={8} className="d-md-flex">
          <InputGroup className="me-2 me-lg-4 fmxw-500">
            <Form.Select
              value={typeFilter}
              style={typeStyle}
              // className="fmxw-150 d-none d-md-inline"
              onChange={changeTypeFilter}
            >
              <option value="">Select Type</option>
              {typeOfSearch?.map((status, index) => (
                <option
                  key={`option-${status?.value}-${index}`}
                  value={status?.value}
                >
                  {status?.label}
                </option>
              ))}
            </Form.Select>
            <Form.Control
              type="text"
              placeholder={searchPlaceholderText}
              value={searchValue}
              onChange={changeSearchValue}
            />
          </InputGroup>
          {/* <Form.Select
            value={statusFilter}
            className="fmxw-200 d-none d-md-inline"
            onChange={changeStatusFilter}
          >
            {searchStatusFilter?.map((status, index) => (
              <option key={`option-${status?.value}-${index}`}>
                {status?.label}
              </option>
            ))}
          </Form.Select> */}
          <Button
            variant="secondary"
            size="sm"
            className="ms-3"
            disabled={disableApply}
            onClick={applyFilterAction}
          >
            {applyLabel}
          </Button>
          {!disableApply ? (
            <Button
              variant="primary"
              size="sm"
              className="ms-3"
              onClick={clearFilter}
            >
              {clearLabel}
            </Button>
          ) : null}
        </Col>
        {/* <Col xs={3} lg={4} className="d-flex justify-content-end">
          <Dropdown as={ButtonGroup}>
            <Dropdown.Toggle
              split
              as={Button}
              variant="link"
              className="text-dark m-0 p-1"
            >
              <CogIcon className="icon icon-sm" />
              <span className="visually-hidden">Toggle Dropdown</span>
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu-xs dropdown-menu-end pb-0">
              <small className="ps-3 fw-bold text-dark">
                {settingsEntriesLabel}
              </small>
              {settingsEntries?.map((item, index) => (
                <Dropdown.Item
                  key={`user-list-table-${item?.value}-${index}`}
                  onClick={changeSettingEntry.bind(null, item.value)}
                >
                  {item.label} {_getCheckIcon(item?.value)}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </Col> */}
      </Row>
    </div>
  );
};

SettingsComp.defaultProps = {
  searchPlaceholderText: "Search users by Name",
  settingsEntriesLabel: "Show",
  applyLabel: "Apply",
  clearLabel: "Clear",
  typeStyle: {
    maxWidth: "140px",
  },
};
